module.exports = "pegasus_template/assets/email1-testi-img.png";